<template>
  <div class="admin-container">
    <!--顶部工具栏-->
    <div class="admin-head-container">
      <el-input v-model="query.value" :clearable="true"
                placeholder="输入文件名称搜索" style="width: 200px; margin-right: 10px"
                class="filter-item" @keyup.enter.native="search"/>
      <el-button class="filter-item" size="mini" type="success" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button class="filter-item" size="mini" type="primary" icon="el-icon-plus" @click="add">新增</el-button>
    </div>
    <!--表格-->
    <el-table v-loading="loading" :data="data" size="small" style="width: 100%;">
      <!--文件名称-->
      <el-table-column prop="download_title" label="名称"/>
      <!--文件大小-->
      <el-table-column label="文件大小" align="center" width="140">
        <template slot-scope="scope">
          <span v-if="SizeToNumber(scope.row['download_size'])>=0 && SizeToNumber(scope.row['download_size'])< 10">
            <el-tag type="success">{{scope.row['download_size']}}</el-tag>
          </span>
          <span v-else-if="SizeToNumber(scope.row['download_size'])>=10 && SizeToNumber(scope.row['download_size'])< 30">
            <el-tag type="warning">{{scope.row['download_size']}}</el-tag>
          </span>
          <span v-else>
            <el-tag type="danger">{{scope.row['download_size']}}</el-tag>
          </span>
        </template>
      </el-table-column>
      <!--文件格式-->
      <el-table-column label="文件格式" align="center" width="180">
        <template slot-scope="scope">
          {{scope.row['download_type']}}
        </template>
      </el-table-column>
      <!--下载次数-->
      <el-table-column label="下载次数" align="center" width="140">
        <template slot-scope="scope">
          {{scope.row['download_times']}}
        </template>
      </el-table-column>
      <!--文件描述-->
      <el-table-column :show-overflow-tooltip="true" label="文件描述">
        <template slot-scope="scope">
          {{delHtmlTag(scope.row['download_intro'])}}
        </template>
      </el-table-column>
      <!--操作-->
      <el-table-column label="操作" width="160px" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="edit(scope.row)"
                     plain style="margin-right: 8px;"/>
          <el-popover
            :ref="scope.row.download_id"
            placement="top"
            width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.download_id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.download_id)">确定
              </el-button>
            </div>
            <el-button slot="reference" type="danger" plain icon="el-icon-delete" size="mini"/>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :total="total"
      :current-page="page"
      background
      style="margin-top: 8px;"
      layout="total, prev, pager, next, sizes"
      @size-change="sizeChange"
      @current-change="pageChange"/>
    <!--新增、编辑表单-->
    <m-form ref="form" :is-add="isAdd" :init="init"/>
  </div>
</template>

<script>
import { delHtmlTag } from '@/utils/index'
import { GetRequest } from '@/api/common'
import { deleteDownload } from '@/api/download'
import MForm from '@/views/AdminDownload/mForm'

export default {
  name: 'AdminDownload',
  components: { MForm },
  data () {
    return {
      loading: true,
      delLoading: false,
      data: [],
      query: {},
      url: '',
      params: {},
      time: 100,
      isAdd: false,
      page: 1,
      size: 10,
      total: 0
    }
  },
  created () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    delHtmlTag,
    beforeInit () {
      this.url = 'api/download'
      this.params = { page_num: this.page, page_size: this.size } // 初始化参数对象
      const query = this.query
      const value = query.value
      if (value) {
        this.params['name'] = value // 获取搜索内容
      }
      return true
    },
    async init () {
      if (!await this.beforeInit()) {
        return
      }
      return new Promise((resolve, reject) => {
        this.loading = true
        GetRequest(this.url, this.params).then(res => {
          if (res.status === 200) {
            this.total = res.body.total
            this.data = res.body.list
            setTimeout(() => {
              this.loading = false
            }, this.time)
            resolve(res)
          } else {
            this.loading = false
            reject(res.msg)
          }
        }).catch(err => {
          this.loading = false
          reject(err)
        })
      })
    },
    search () {
      this.page = 1
      this.init()
    },
    add () {
      this.isAdd = true
      this.$refs.form.dialog = true
    },
    edit (row) {
      this.isAdd = false
      this.$refs.form.form = {
        download_id: row.download_id,
        download_title: row.download_title,
        md_download_intro: row.md_download_intro,
        html_download_intro: row.download_intro,
        apply_to_product: Number(row.apply_to_product),
        product_ids: row.product_ids
      }
      this.$store.commit('SET_MDVALUE', row.md_download_intro)
      this.$store.commit('SET_MDHTML', row.download_intro)
      this.$refs.form.dialog = true
    },
    subDelete (uuid) {
      this.delLoading = true
      deleteDownload(uuid).then(res => {
        if (res.status === 200) {
          this.delLoading = false
          this.$refs[uuid].doClose()
          if (this.data.length === 1) {
            this.page -= 1
          }
          if (this.page < 1) {
            this.page = 1
          }
          this.init()
          this.$notify({
            title: '删除成功',
            type: 'success',
            duration: 3000
          })
        } else {
          this.delLoading = false
          this.$refs[uuid].doClose()
          this.$notify({
            title: '删除错误',
            type: 'error',
            message: res.msg,
            duration: 3000
          })
        }
      }).catch(err => {
        console.log(err)
        this.delLoading = false
        this.$refs[uuid].doClose()
        this.$notify({
          title: '删除错误',
          type: 'error',
          message: err,
          duration: 3000
        })
      })
    },
    /**
     * @description 页码改变事件
     * */
    pageChange (e) {
      this.page = e
      this.init()
    },
    /**
     * @description 每页数量改变事件
     * */
    sizeChange (e) {
      this.page = 1
      this.size = e
      this.init()
    },
    /**
     * @description 将文件大小转为数字
     * @return {number}
     */
    SizeToNumber (value) {
      let unit = value.substr(value.length - 2, 2)
      if (unit === 'kB') {
        return Number(value.substr(0, value.length - 3)) / 1024
      } else {
        return Number(value.substr(0, value.length - 3))
      }
    }
  }
}
</script>

<style>
  .el-tooltip__popper {
    max-width: 800px;
  }
</style>
